import type { SVGProps } from 'react';
import * as React from 'react';

const UserPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/user-plus">
      <g id="Icon">
        <path
          d="M12 6.00039C12 7.98862 10.3882 9.60039 8.39998 9.60039C6.41175 9.60039 4.79998 7.98862 4.79998 6.00039C4.79998 4.01217 6.41175 2.40039 8.39998 2.40039C10.3882 2.40039 12 4.01217 12 6.00039Z"
          fill="currentColor"
        />
        <path
          d="M1.93831 19.714C1.46155 19.4087 1.18539 18.8656 1.25524 18.3039C1.69696 14.7508 4.7273 12.0004 8.39986 12.0004C12.0724 12.0004 15.1027 14.7501 15.5445 18.303C15.6143 18.8648 15.3382 19.4078 14.8614 19.7131C12.9962 20.9074 10.7789 21.6004 8.39986 21.6004C6.02082 21.6004 3.80348 20.9081 1.93831 19.714Z"
          fill="currentColor"
        />
        <path
          d="M19.5 6.90039C19.5 6.40333 19.097 6.00039 18.6 6.00039C18.1029 6.00039 17.7 6.40333 17.7 6.90039V9.30039H15.3C14.8029 9.30039 14.4 9.70334 14.4 10.2004C14.4 10.6974 14.8029 11.1004 15.3 11.1004H17.7V13.5004C17.7 13.9974 18.1029 14.4004 18.6 14.4004C19.097 14.4004 19.5 13.9974 19.5 13.5004V11.1004H21.9C22.397 11.1004 22.8 10.6974 22.8 10.2004C22.8 9.70334 22.397 9.30039 21.9 9.30039H19.5V6.90039Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default UserPlusIcon;
